export const ACCESS_ROLES = [
  { value: 'staff', label: 'Staff', hint: 'View calls and handle requests, messages and bookings.' },
  { value: 'manager', label: 'Manager', hint: 'Manage day-to-day operations and settings (not team members).' },
  { value: 'owner', label: 'Owner', hint: 'Full access, including managing team members.' }
];

export const ROLE_HINTS = Object.fromEntries(ACCESS_ROLES.map((r) => [r.value, r.hint]));

export function previewAs(user, permissions, previewRole, presets = {}) {
  if (!user || !previewRole) return { user, permissions };
  return {
    user: { ...user, role: previewRole, userType: 'client_user' },
    permissions: presets[previewRole] || permissions
  };
}
